// AI request templates per scenario.
// Each request has urgency (1-4), sensitivity (1-4), owner role, and proposed action.
// flow tag identifies which scripted demo flow it primarily illustrates:
//   "low" = low-severity advisory, "escalating" = needs review, "sensitive" = cross-boundary

export const REQUESTS_BY_SCENARIO = {
  "urban-flooding": [
    {
      id: "uf-r1",
      title: "Draft public service status update",
      summary: "Generate a 280-character status post for the council channel summarising current bus diversions.",
      urgency: 1,
      sensitivity: 1,
      ownerRole: "Communications Lead",
      proposedAction: "Publish public status post (advisory)",
      flow: "low",
    },
    {
      id: "uf-r2",
      title: "Re-route guidance for priority care visits",
      summary: "Recommend safe alternative routes for 12 outstanding care-visit appointments in Zone B.",
      urgency: 3,
      sensitivity: 2,
      ownerRole: "Operations Lead",
      proposedAction: "Issue routing guidance to care providers",
      flow: "escalating",
    },
    {
      id: "uf-r3",
      title: "Share resident impact list with mutual-aid partner",
      summary: "Disclose at-risk-resident shortlist (ground-floor properties, mobility flags) to neighbouring authority for joint response.",
      urgency: 3,
      sensitivity: 4,
      ownerRole: "Duty Manager",
      proposedAction: "Selective disclosure to External Partner",
      flow: "sensitive",
    },
    {
      id: "uf-r4",
      title: "Estimate downstream tram-network delay",
      summary: "Forecast tram delay propagation across the next 90 minutes given current conditions.",
      urgency: 2,
      sensitivity: 1,
      ownerRole: "Operations Lead",
      proposedAction: "Internal forecast for ops planning",
      flow: "low",
    },
  ],
  heatwave: [
    {
      id: "hw-r1",
      title: "Auto-generate cooling-centre opening notice",
      summary: "Draft and schedule a notice listing open cooling centres and opening hours.",
      urgency: 1,
      sensitivity: 1,
      ownerRole: "Communications Lead",
      proposedAction: "Publish public notice (advisory)",
      flow: "low",
    },
    {
      id: "hw-r2",
      title: "Prioritise welfare calls — over-75s in Zone B",
      summary: "Re-rank the 240 outstanding wellbeing calls based on heat risk + last-contact date.",
      urgency: 3,
      sensitivity: 3,
      ownerRole: "Local Service Coordinator",
      proposedAction: "Push reordered call list to care providers",
      flow: "escalating",
    },
    {
      id: "hw-r3",
      title: "Share vulnerable-resident roster with DNO",
      summary: "Disclose priority-services-register list to Distribution Network Operator for outage prioritisation.",
      urgency: 3,
      sensitivity: 4,
      ownerRole: "Duty Manager",
      proposedAction: "Selective disclosure to External Partner (DNO)",
      flow: "sensitive",
    },
    {
      id: "hw-r4",
      title: "Forecast peak demand window",
      summary: "Estimate the 30-min window of peak grid load over the next 6 hours.",
      urgency: 2,
      sensitivity: 1,
      ownerRole: "Operations Lead",
      proposedAction: "Internal forecast for ops planning",
      flow: "low",
    },
  ],
  "rail-incident": [
    {
      id: "ri-r1",
      title: "Compose passenger update for affected services",
      summary: "Draft a clear update for in-service trains and station displays describing the disruption.",
      urgency: 2,
      sensitivity: 1,
      ownerRole: "Communications Lead",
      proposedAction: "Push public update to PIS / station displays",
      flow: "low",
    },
    {
      id: "ri-r2",
      title: "Coach replacement plan — recommend allocations",
      summary: "Recommend coach allocations across the 5 held services using available contracted operators.",
      urgency: 3,
      sensitivity: 2,
      ownerRole: "Operations Lead",
      proposedAction: "Dispatch coach allocation plan",
      flow: "escalating",
    },
    {
      id: "ri-r3",
      title: "Authorise welfare-data share with British Transport Police",
      summary: "Share onboard passenger welfare list (medical flags, accompanied minors) with BTP for safe detrainment.",
      urgency: 4,
      sensitivity: 4,
      ownerRole: "Duty Manager",
      proposedAction: "Selective disclosure to External Partner (BTP)",
      flow: "sensitive",
    },
    {
      id: "ri-r4",
      title: "Estimate onward connection impact",
      summary: "Forecast connection-miss counts at York for the next 2 hours.",
      urgency: 2,
      sensitivity: 1,
      ownerRole: "Operations Lead",
      proposedAction: "Internal forecast for ops planning",
      flow: "low",
    },
  ],
};
